import {FC, ReactElement} from 'react';
import {
  IconWithBackgroundSecondWrapper,
  IconWithBackgroundSuccessWrapper,
  IconWithBackgroundWrapper,
} from '@atoms/IconWithBackground.styles';
import {CheckmarkFilled} from '@carbon/icons-react';
import {theme} from '@styles/theme';

export interface TextProps {
  icon: ReactElement;
  successMark?: boolean;
}

const IconWithBackground: FC<TextProps> = ({icon, successMark = false}) => {
  return (
    <IconWithBackgroundWrapper>
      <IconWithBackgroundSecondWrapper>{icon}</IconWithBackgroundSecondWrapper>
      {successMark && (
        <IconWithBackgroundSuccessWrapper>
          <CheckmarkFilled size={16} fill={theme.colors.signalGreen00} />
        </IconWithBackgroundSuccessWrapper>
      )}
    </IconWithBackgroundWrapper>
  );
};

export default IconWithBackground;
